export const getDateYearsBetweenDates = (startDate: Date, endDate: Date) => {
	const years: Date[] = [];

	for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
		years.push(new Date(year, 0, 1));
	}

	return years;
};
